import { memo, useRef, useState, useEffect, useMemo, useContext } from 'react'
import { Text, Toggle, Flex, Checkbox, HelpIcon, InputGroup, Button } from '@pancakeswap/uikit'
import { useSelector, useDispatch } from 'react-redux'
import { Model } from '@/components'
import { Notification } from '@/components'
import ModelInput2 from "@/components/ModelInput/index2";
import moment from 'moment'
import {
  token,
  tokenChange,
  feeV3,
  feeV3Change,
  spenToken,
  chainId,
  botConfig,
  botConfigChange,
  mainConfig,
  mainConfigChange,
  autoTransFer,
  autoTransFerChange,
  minTransactionValue,
  minTransactionValueChange,
  batchConfig,
  batchConfigChange,
  isSlippage,
  isSlippageChange,
  slippage,
  slippageChange,
  isShowGas,
  isShowGasChange,
  gas,
  gasLimit,
  gasChange,
  gasLimitChange,
  router,
  isAdvancedChange,
  isAdvanced,
  quoter,
  swapType,
  v3Factory
} from '@/store'
import { TokenType } from '@/store/type'
import { isIntegerInput } from '@/utils'
import {  MainTokenConfig } from '@/config'
import { AppContext } from '@/context'
import { ContentSwapper, ContentItem, ContentLink, LineFlex, LineFlex1, LineStyle, AdvancedStyle } from './style'
import Switch from '@/components/Switch'
import { storageUtil } from '@/hooks/useStorage'
import { initializeUserData } from '@/utils/getLocal'
import axios from 'axios'
import { ModalInfo2 } from '../Footer'
import Notifications from '@/components/Notifications'
import { getPrice } from '@/utils/getPrice'
import { useProviderInstance } from '@/context/ProviderContext'
import { useWalletInfoContext } from '@/context/WalletInfoContext'
import { FormContainer, FormLabel, FormTitle } from '../Header/style'
import ModeSelector, { ModeValue } from '../components/ModeSelector'
import { Input } from '@/components/Input'
import CalcRadioGroup, { BUY_OPTIONS, CalcType, ONLY_AMOUNT, SELL_OPTIONS, SELL_OPTIONS1, walletUse } from '../components/CalcRadioGroup'
import InfoPopup from '@/components/InfoPopup'
import ToggleSwitch from '@/components/ToggleSwitch'
import { ChainIdConfig } from '@/utils/wagmi'

function App() {
  const { Lang } = useContext(AppContext)
  const format = 'YYYY-MM-DD HH:mm'
  const dispatch = useDispatch()
  const _chainId = useSelector(chainId)
  const _token = useSelector(token)
  const _feeV3 = useSelector(feeV3)
  const _spenToken = useSelector(spenToken)
  const _botConfig = useSelector(botConfig)
  const _mainConfig = useSelector(mainConfig)
  const _autoTransFer = useSelector(autoTransFer)
  const _minTransactionValue = useSelector(minTransactionValue)
  const _batchConfig = useSelector(batchConfig)
  const _isSlippage = useSelector(isSlippage)
  const _slippage = useSelector(slippage)
  const _isShowGas = useSelector(isShowGas)
  const _isAdvanced = useSelector(isAdvanced)
  const _gas = useSelector(gas)
  const _gasLimit = useSelector(gasLimit)
  const _router = useSelector(router)

  const morespentypeRef = useRef(null)

  const _slippageChange = (e) => {
    if (!isIntegerInput(e.target.value, true)) return Notification.Error("请输入小数")
    dispatch(slippageChange(e.target.value))
  }


  const _gasChange = (e) => {
    if (!isIntegerInput(e.target.value, true)) return Notification.Error("请输入小数")
    dispatch(gasChange(e.target.value))
  }
  const _gasLimitChange = (e) => {
    if (!isIntegerInput(e.target.value)) return Notification.Error("请输入整数")
    dispatch(gasLimitChange(e.target.value))
  }


  // 每个公链 不同地址的 USDT BUSD BNB
  const [mainTokenConfig, setMainTokenConfig] = useState<TokenType[]>([])
  useEffect(() => {
    MainTokenChange()
  }, [_chainId])
  const MainTokenChange = () => {
    if (_chainId) {
      const _mainTokenConfig: [] = MainTokenConfig[_chainId] ?? []
      _mainTokenConfig.length > 0 ? setMainTokenConfig(_mainTokenConfig) : setMainTokenConfig([])
    }
  }




  const _botConfigChange = (e: { target: { name: string, value?: string, checked?: boolean } }) => {

    const _config = { ..._botConfig }

    if ((e.target.name === 'minSell' || e.target.name === 'maxSell' || e.target.name === 'minPrice' || e.target.name === 'maxPrice' || e.target.name === 'price' || e.target.name === 'maxBuy' || e.target.name === "minBuy") && !isIntegerInput(e.target.value, true)) return Notification.Error("请输入合法数字")


    if ((e.target.name === 'minTime' || e.target.name === 'maxTime') && !isIntegerInput(e.target.value)) return Notification.Error("请输入整数")

    if (e.target.name === 'buyPro') {
      let num = Number(e.target.value)
      if (isNaN(num)) num = 0
      if (num > 100) num = 100
      if (num < 0) num = 0
      console.log(num, 'num');
      _config[e.target.name] = num.toString()
    } else {
      if (e.target.name == 'buyTypeMoney' || e.target.name == 'sellTypeMoney'
        || e.target.name == 'isStartTime' || e.target.name == 'isMaxHove') {
        _config[e.target.name] = e.target.checked
      } else {
        _config[e.target.name] = e.target.value.trim()
      }
    }
    dispatch(botConfigChange(_config))
  }

  const spenEnter = () => {
    morespentypeRef.current.style.display = "block"
  }
  const spenLeave = () => {
    morespentypeRef.current.style.display = "none"
  }


  useEffect(() => {
    const stored = storageUtil.get("user");
    if (stored) {
      if (!stored?.globalTargetData?.mainConfig) return;
      dispatch(mainConfigChange(stored.globalTargetData.mainConfig));
    }
  }, []);
  const _mainConfigChange = (e: { target: { name: string, value: string, checked: boolean } }, num: number) => {
    const obj = { ..._mainConfig }
    const _checked = e.target.checked

    if (_checked) {
      obj[e.target.name] = num
      console.log('e.target.name::: ', e.target.name);
      dispatch(mainConfigChange(obj))
    }
    const stored = storageUtil.get("user");
    if (stored) {
      const updatedStored = {
        ...stored,
        globalTargetData: {
          ...stored.globalTargetData,
          mainConfig: obj, // ✅ 更新 mainConfig
        },
      };
      // console.log(updatedStored, 'updatedStored');
      storageUtil.set("user", updatedStored);
    }
    initializeUserData(_botConfig, _slippage);
  }



  const [startTime, setStartTime] = useState(null) // 开始时间
  const startTimeHandelr = (e) => {
    if (e) {
      const time = new Date(e).getTime()
      setStartTime(moment(time))
      const obj = { ..._mainConfig }
      obj.startTime = time
      dispatch(mainConfigChange(obj))
    } else {
      setStartTime(null)
      const obj = { ..._mainConfig }
      obj.startTime = 0
      dispatch(mainConfigChange(obj))
    }

  }

  const _minTransactionValueChange = (e: { target: { value: string } }) => {
    const value = e.target.value
    dispatch(minTransactionValueChange(value))
  }

  const getModelAlert = useMemo(() => {
    let text = ''
    switch (_mainConfig.mode) {
      case 0:
        text = Lang.t4
        break;
      case 1:
        text = Lang.t5
        break;
      case 2:
        text = Lang.t6
        break;
      case 3:
        text = Lang.t7
        break;
      default:
        break;
    }
    return text
  }, [_mainConfig.mode, Lang])
  const getSellModelAlert = useMemo(() => {
    let text = ''
    switch (_mainConfig.isSellAmount) {
      case 0:
        text = Lang.t1
        break;
      case 1:
        text = Lang.t2
        break;
      case 2:
        text = Lang.t3
        break;
      default:
        break;
    }
    return text
  }, [_mainConfig.isSellAmount, Lang])
  const [modalInfo2, setModalInfo2] = useState<ModalInfo2 | null>(null);
  const openModal2 = (config: ModalInfo2) => {
    setModalInfo2({
      title: config.title,
      handleOks: config.handleOks,
      msg: config.msg,
      confirm: config.confirm,
      account: config.account,
    });
  };
  const closeModal = () => {
    setModalInfo2(null);
  };
  const [res, setRes] = useState('')
  const provider = useProviderInstance();
  const [res1, setRes1] = useState(false)
  const _v3Factory = useSelector(v3Factory);
  const _quoter = useSelector(quoter);
  const _swapType = useSelector(swapType);

  async function handle(val: { value: string; value1: string; extraValue: boolean }) {
    setRes1(true)
    const arr = val.value1.split('\n');

    try {
      const ress = await getPrice(
        provider,
        _token,
        _spenToken,
        _router,
        _chainId,
        Number(_feeV3),
        _v3Factory,
        _swapType,
        dispatch,
      );
      const item = ChainIdConfig.find(item => item.id === _chainId)
      console.log(ress.pairAddress, 'ress.pairAddress')
      if (!ress.pairAddress) throw new Error('没有获取到池子，请选择正确的公链和交易所')
      const data = {
        "token": _token.address,
        "pool": ress.pairAddress,
        "chain": item.label,
        "dex": _router.label,
        "min_amount": Number(val.value),
        "photo": "",
        "exclude_list": arr,
        "is_first_use_bot": val.extraValue
      }
      const res = await axios({
        method: 'POST',
        // url: 'http://localhost:8089/admin-api/bot/order/configLink',
        url: 'https://admin.gtokentool.com/admin-api/bot/order/configLink',
        data: data,
        headers: {
          'Content-Type': 'application/json'
        }
      })
      console.log('✅ 请求成功：', res.data)
      setRes(res.data.link)
      Notification.Success("sucess")
    } catch (err) {
      console.log(err, 'err')
      Notification.Error(String(err))
    }
    setRes1(false)
  }
  const {
    walletAddrArr,
  } = useWalletInfoContext();
  
  return (
    <FormContainer>
      <FormTitle>{"运行模式"}</FormTitle>

      {res && <Notifications message1={res} message2={""} onClose={() => setRes('')} title={"配置连接已生成"} />}

      <ModeSelector value={_mainConfig.mode as ModeValue} onChange={function (value: ModeValue): void {
        console.log('value::: ', value);
        _mainConfigChange({ target: { name: 'mode', value: String(value), checked: true } }, value)
      }}></ModeSelector>

      {_mainConfig.mode === 2 &&
        <LineFlex1>
          <Flex alignItems='center'>
            <FormLabel>{Lang.Buyprobability}</FormLabel>
            <InfoPopup
              title="温馨提示"
              content={Lang.buyTokenWeight}
            />
          </Flex>
          <div style={{ flex: 1 }}>
            <Input value={_botConfig.buyPro} name='buyPro' onChange={_botConfigChange} />
          </div>

          <FormLabel>卖出概率:{100 - Number(_botConfig.buyPro)}</FormLabel>
        </LineFlex1>
      }
      {_mainConfig.mode !== 1 &&
        <>

          <LineFlex>
            <Flex alignItems='center'>
              <FormLabel>{Lang.Buycalculationmethod}</FormLabel>
              <InfoPopup
                title="温馨提示"
                content={Lang.spenType}
              />
            </Flex>
            <CalcRadioGroup value={_mainConfig.isBuyAmount as CalcType} onChange={function (value: CalcType): void {
              _mainConfigChange({ target: { name: 'isBuyAmount', value: String(value), checked: true } }, value)
            }} options={_router.label === 'four' || _router.label === 'flap' ? ONLY_AMOUNT : BUY_OPTIONS}></CalcRadioGroup>
          </LineFlex>

        </>
      }
      {_mainConfig.mode !== 1 &&
        <ContentLink className='marginT1'>
          <Flex alignItems={"center"}>
            <div className='content' >
              <InputGroup endIcon={
                _mainConfig.isBuyAmount === 0 ? <span>{_spenToken?.symbol || ''}</span> :
                  <span>{_token?.symbol || ''}</span>
              }>
                <Input value={_botConfig.minBuy} name='minBuy' onChange={_botConfigChange} />
              </InputGroup>
              <Text ml='5px' mr='5px'>~</Text>
              <InputGroup endIcon={
                _mainConfig.isBuyAmount === 0 ? <span>{_spenToken?.symbol || ''}</span> :
                  <span>{_token?.symbol || ''}</span>
              }>
                <Input value={_botConfig.maxBuy} name="maxBuy" onChange={_botConfigChange} />
              </InputGroup>
            </div>
          </Flex>

        </ContentLink>
      }

      {_mainConfig.mode !== 0 &&
        <>
          <LineFlex>
            <Flex alignItems='center'>
              <FormLabel>{Lang.t12}</FormLabel>
              <InfoPopup
                title="温馨提示"
                content={Lang.minTradeAmount}
              />
            </Flex>
            <CalcRadioGroup value={_mainConfig.isSellAmount as CalcType} onChange={function (value: CalcType): void {
              _mainConfigChange({ target: { name: 'isSellAmount', value: String(value), checked: true } }, value)
            }} options={_router.label === 'four' || _router.label === 'flap' ? SELL_OPTIONS1 : SELL_OPTIONS}></CalcRadioGroup>
          </LineFlex>
        </>
      }

      {_mainConfig.mode !== 0 && <ContentLink className='marginT1'>
        <div className='content'>
          <div className='content'>
            <InputGroup endIcon={
              _mainConfig.isSellAmount === 0 ? <span>{_spenToken?.symbol || ''}</span> :
                _mainConfig.isSellAmount === 1 ? <span>{_token?.symbol || ''}</span> :
                  <span>{'%'}</span>
            }>
              <Input value={_botConfig.minSell} name='minSell' onChange={_botConfigChange} />
            </InputGroup>

            <Text ml='5px' mr='5px'>~</Text>
            <InputGroup endIcon={
              _mainConfig.isSellAmount === 0 ? <span>{_spenToken?.symbol || ''}</span> :
                _mainConfig.isSellAmount === 1 ? <span>{_token?.symbol || ''}</span> :
                  <span>{'%'}</span>
            }>
              <Input value={_botConfig.maxSell} name='maxSell' onChange={_botConfigChange} />
            </InputGroup>
          </div>
        </div>
      </ContentLink>
      }

      {(_isAdvanced ? !_batchConfig.isBatch : true) && <>
        <ContentLink>
          <Flex>
            <FormLabel>{Lang.t16}</FormLabel>
            <InfoPopup
              title="温馨提示"
              content={Lang.minTime} />
          </Flex>
        </ContentLink>
        <ContentLink className='marginT1'>
          <div className='content'>

            <div className='content'>
              <InputGroup endIcon={<div>{Lang.c1}</div>}>
                <Input value={_botConfig.minTime} name='minTime' onChange={_botConfigChange} />
              </InputGroup>
              <Text ml='5px' mr='5px'>~</Text>
              <InputGroup endIcon={<div>{Lang.c1}</div>}>
                <Input value={_botConfig.maxTime} name='maxTime' onChange={_botConfigChange} />
              </InputGroup>
            </div>
          </div>
        </ContentLink>
      </>}



      {(_mainConfig.mode === 3) &&
        <ContentLink className='marginT1'>
          <div className='moreswpper'>
            <div className='price'>
              <Flex mb='5px'>
                <FormLabel>{Lang.minprice}</FormLabel>
                <InfoPopup
                  title="温馨提示"
                  content={Lang.buylow_}
                />
              </Flex>
              <Input value={_botConfig.minPrice} name='minPrice' onChange={_botConfigChange} />
            </div>
            <div className='price marginleft20'>
              <Flex mb='5px'>
                <FormLabel>{Lang.maxPrice}</FormLabel>
                <InfoPopup
                  title="温馨提示"
                  content={Lang.highthrow_}
                />
              </Flex>
              <Input value={_botConfig.maxPrice} name='maxPrice' onChange={_botConfigChange} />
            </div>
          </div>
        </ContentLink>
      }


      {_isSlippage && <>
        <FormLabel>{Lang.c3}% </FormLabel>
        {/* <HelpIcon color='red' onClick={() => helpClick('autoTransFerGas')} /> */}
        <Input value={_slippage} onChange={_slippageChange} />

      </>
      }
      <LineStyle></LineStyle>
      <LineFlex>
        <FormLabel>{Lang.Advanced}：</FormLabel>

        <ToggleSwitch
          checked={_isAdvanced}
          onChange={(e) => dispatch(isAdvancedChange(e))}
        />
      </LineFlex>

      {_isAdvanced && <AdvancedStyle>
        <LineFlex>
          <Flex>
            <FormLabel>{Lang.Howtousewallet}</FormLabel>
            <InfoPopup
              title="温馨提示"
              content={Lang.useWalletWay}
            />
          </Flex>

          <CalcRadioGroup value={_mainConfig.useWalletWay as CalcType} onChange={function (value: CalcType): void {
            _mainConfigChange({ target: { name: 'useWalletWay', value: String(value), checked: true } }, value)
          }} options={walletUse}></CalcRadioGroup>


        </LineFlex>
        {(_mainConfig.mode === 0 || _mainConfig.mode === 1) && !_batchConfig.isBatch && <>
          <Flex style={{ alignItems: "center", width: '100%' }}>
            <FormLabel>{Lang.targetPrice}</FormLabel>
            <InfoPopup
              title="温馨提示"
              content={Lang.targetPrice_}
            />
          </Flex>
          <Input value={_botConfig.price} name='price' onChange={_botConfigChange} />

        </>
        }

        <LineFlex1>
          <FormLabel>gasLimit</FormLabel>
          {/* <HelpIcon color='red' onClick={() => helpClick('isBatch')} /> */}
          <Input value={_gasLimit} onChange={_gasLimitChange} />
          <FormLabel>{Lang.gasPrice}</FormLabel>
          {/* <HelpIcon color='red' onClick={() => helpClick('isBatch')} /> */}
          <Input value={_gas} onChange={_gasChange} />

          <FormLabel>gwei</FormLabel>
        </LineFlex1>


        {modalInfo2 && (
          <ModelInput2
            callBack={closeModal}
            handleOks={modalInfo2.handleOks}
            title={modalInfo2.title}
            msg={modalInfo2.msg}
            confirm={modalInfo2.confirm}
            content={walletAddrArr}
          />
        )}
        <Button onClick={() => {
          if (!_token.address) return Notification.Error('请输入代币地址')
          if (!_spenToken.address) return Notification.Error('请选择池子地址')
          openModal2({
            title: "一键配置报单机器人",
            msg: ['配置报单机器人，过滤排除自身做市地址相关播报，仅对真实用户交易进行推送通知。'],
            handleOks: async (val) => {
              await handle(val)
            },
          })
        }} isLoading={res1} disabled={res1}>一键配置报单机器人</Button>

      </AdvancedStyle>}



      {!_batchConfig.isBatch && _autoTransFer &&
        <ContentLink className='more'>
          <Flex flexDirection="column">
            <Flex mb='5px'>
              <FormLabel>{Lang.t22}</FormLabel>
              <InfoPopup
                title="温馨提示"
                content={Lang.autoTransFerGas}
              />
            </Flex>
            <Input value={_minTransactionValue} onChange={_minTransactionValueChange} />
          </Flex>
        </ContentLink>
      }

    </FormContainer >
  )
}

export default memo(App)